import { useMutation } from '@tanstack/react-query';
import { useApi } from '../../lib/api';

export interface RequestResetPayload {
  email: string;
}

export function useRequestReset() {
  const api = useApi();
  return useMutation({
    mutationFn: async ({ email }: RequestResetPayload): Promise<void> => {
      const { error, response } = (await api.POST('/auth/password/reset-request' as never, {
        body: { email },
      } as never)) as { data?: unknown; error?: unknown; response: Response };
      if (error) {
        const err = new Error('reset_request_failed') as Error & {
          status?: number;
          body?: unknown;
        };
        err.status = response?.status;
        err.body = error;
        throw err;
      }
    },
  });
}
